import React, { useState, useEffect } from 'react';
import { useStateValue } from '../StateProvider';
import './Orders.css';
import { db } from '../firebase';
import OrderProduct from './OrderProduct';

function Orders() {
    const [{ basket, user }, dispatch] = useStateValue();
    const [orders, setOrders] = useState([]);

    useEffect(() => {
        if (user) {
            db.collection('users')
              .doc(user?.uid)
              .collection('orders')
              .orderBy('created', 'desc')
              .onSnapshot(snapshot => (
                  setOrders(snapshot.docs.map(doc => ({
                      id: doc.id,
                      data: doc.data()
                  })))
              ));
        } else {
            setOrders([]);
        }
    }, [user])

    return (
        <div className="orders">
            <h1>Your Orders</h1>
            <div className="orders__order">
                {orders?.map(order => (
                    <OrderProduct order={order} />
                ))}
            </div>
        </div>
    )
}

export default Orders
